import { Track } from 'livekit-client';

type ParticipantPermissions = {
  canPublish?: boolean;
  canPublishSources?: unknown[];
};

const normalizedSourceAliases: Record<Track.Source, string[]> = {
  [Track.Source.Camera]: ['camera', '1'],
  [Track.Source.Microphone]: ['microphone', 'mic', '2'],
  [Track.Source.ScreenShare]: ['screen_share', 'screenshare', '3'],
  [Track.Source.ScreenShareAudio]: [
    'screen_share_audio',
    'screenshareaudio',
    '4',
  ],
  [Track.Source.Unknown]: ['unknown', '0'],
};

const sourceValueFromObject = (source: object) => {
  const record = source as Record<string, unknown>;
  return (
    record.name ??
    record.value ??
    record.source ??
    record.no ??
    record.number ??
    record.id
  );
};

const normalizePublishSource = (source: unknown): string => {
  if (source && typeof source === 'object') {
    const objectValue = sourceValueFromObject(source);
    if (objectValue !== undefined) {
      return normalizePublishSource(objectValue);
    }
  }

  return String(source ?? '')
    .trim()
    .toLowerCase()
    .replace(/^livekit[._-]?track[._-]?source[._-]?/, '')
    .replace(/^track[._-]?source[._-]?/, '')
    .replace(/[\s.-]+/g, '_');
};

export const canPublishSource = (
  permissions: ParticipantPermissions | undefined,
  source: Track.Source,
) => {
  if (permissions?.canPublish === false) return false;
  const allowedSources = permissions?.canPublishSources;
  if (!allowedSources || allowedSources.length === 0) return true;

  const sourceAliases =
    normalizedSourceAliases[source]?.map(normalizePublishSource) || [];
  return allowedSources.some((allowedSource) =>
    sourceAliases.includes(normalizePublishSource(allowedSource)),
  );
};

export const participantCanPublishSource = (
  participant: unknown,
  source: Track.Source,
) =>
  canPublishSource(
    (participant as { permissions?: ParticipantPermissions } | undefined)
      ?.permissions,
    source,
  );
